if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // Kokoch: loading também no botão fixo (sticky) e na tela
      this.kkButtons = [this.submitButton];
      if (this.form.id) {
        document.querySelectorAll('button[form="' + this.form.id + '"][type="submit"]').forEach((b) => {
          if (this.kkButtons.indexOf(b) === -1) this.kkButtons.push(b);
        });
      }
      if (evt.submitter && this.kkButtons.indexOf(evt.submitter) === -1) this.kkButtons.push(evt.submitter);
      this.kkButtons.forEach((b) => {
        b.classList.add('loading');
        b.setAttribute('aria-disabled', true);
        const sp = b.querySelector('.loading-overlay__spinner');
        if (sp) sp.classList.remove('hidden');
      });
      window.kkAtcOverlay && window.kkAtcOverlay(true);
      const kkStart = Date.now();
      const kkMinWait = (value) => new Promise((resolve) => setTimeout(() => resolve(value), Math.max(0, 800 - (Date.now() - kkStart))));

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      } 
      
      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(kkMinWait)
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          (this.kkButtons || []).forEach((b) => {
            b.classList.remove('loading');
            if (!this.error) b.removeAttribute('aria-disabled');
            const sp = b.querySelector('.loading-overlay__spinner');
            if (sp) sp.classList.add('hidden');
          });
          window.kkAtcOverlay && window.kkAtcOverlay(false);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/* Kokoch: overlay de carregamento na tela ao adicionar ao carrinho */
(function () {
  if (window.kkAtcOverlay) return;
  var el;
  window.kkAtcOverlay = function (show) {
    if (!el) {
      el = document.createElement('div');
      el.className = 'kk-atc-overlay';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<div class="kk-atc-overlay__box"><span class="kk-atc-overlay__spinner"></span></div>';
      document.body.appendChild(el);
    }
    el.classList.toggle('is-active', !!show);
  };
})();
